import type { FunctionComponent } from 'react';

import {
    GroupContainer,
    GroupContent,
    GroupLabel,
    ItemsContainer,
    TimelineDot,
    TimelineLine,
    TimelineVisual,
} from './timeline-styles';
import type { TimelineGroupProps } from './timeline-types';

export const TimelineGroup: FunctionComponent<TimelineGroupProps> = ({
    children,
    className,
    contentClassName,
    itemsClassName,
    itemsRef,
    isLastGroup = false,
    label,
    showTimeline = true,
}) => {
    return (
        <GroupContainer className={className}>
            {showTimeline ? (
                <TimelineVisual>
                    <TimelineDot />
                    <TimelineLine isLastGroup={isLastGroup} />
                </TimelineVisual>
            ) : null}
            <GroupContent className={contentClassName}>
                <GroupLabel>{label}</GroupLabel>
                <ItemsContainer ref={itemsRef} className={itemsClassName}>
                    {children}
                </ItemsContainer>
            </GroupContent>
        </GroupContainer>
    );
};
